// Mock data for Sumit Corporate Services website

export const companyInfo = {
  name: "Sumit Corporate Services",
  tagline: "Your Trusted Partner for Corporate Excellence",
  description: "Empowering businesses with comprehensive corporate services including company formation, accounting, tax advisory, and strategic consultancy.",
  whatsapp: "+971507163176",
  email: "info@sumit.ae",
  address: "Meydan Free Zone, Dubai"
};

export const services = [
  {
    id: 1,
    title: "Company Formation & Registration",
    description: "Seamless business setup across multiple jurisdictions with end-to-end support for licensing, documentation, and regulatory compliance.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=80&auto=format&fit=crop&w=960",
    features: ["Free zone & mainland setup", "Trade license processing", "MOA & AOA preparation", "Visa processing"]
  },
  {
    id: 2,
    title: "Accounting & Bookkeeping",
    description: "Professional financial management services ensuring accuracy, compliance, and strategic insights for your business growth.",
    icon: "Calculator",
    image: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFjY291bnRpbmclMjBkb2N1bWVudHMlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcxMDYwNjI2fDA&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=960",
    features: ["Monthly bookkeeping", "Financial statements", "Accounts reconciliation", "Payroll management"]
  },
  {
    id: 3,
    title: "Tax Services",
    description: "Comprehensive tax planning and compliance services designed to optimize your tax position while ensuring full regulatory adherence.",
    icon: "Receipt",
    image: "https://images.unsplash.com/photo-1768839724256-28cd4a373209?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGFjY291bnRpbmclMjBkb2N1bWVudHMlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcxMDYwNjI2fDA&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=960",
    features: ["VAT registration & filing", "Corporate tax advisory", "Tax planning", "Tax audit support"]
  },
  {
    id: 4,
    title: "HR Services",
    description: "Strategic human resource solutions covering recruitment, payroll, compliance, and employee management systems.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1468779036391-52341f60b55d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGFjY291bnRpbmclMjBkb2N1bWVudHMlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcxMDYwNjI2fDA&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=960",
    features: ["Recruitment services", "HR policy development", "Employee contracts", "Performance management"]
  },
  {
    id: 5,
    title: "Management Consultancy",
    description: "Expert business advisory services focused on strategy, operations, and sustainable growth for your organization.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1758518730037-a16581a040e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbHMlMjBtZWV0aW5nfGVufDB8fHx8MTc3MTA2MDU0M3ww&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=960",
    features: ["Business strategy", "Process optimization", "Market analysis", "Growth planning"]
  },
  {
    id: 6,
    title: "Corporate Governance & Compliance",
    description: "Robust governance frameworks and compliance programs ensuring your business meets all regulatory requirements.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1605250803010-37d03931db8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw1fHxidXNpbmVzcyUyMGFjY291bnRpbmclMjBkb2N1bWVudHMlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcxMDYwNjI2fDA&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=960",
    features: ["Board governance", "Compliance audits", "Risk management", "Policy frameworks"]
  },
  {
    id: 7,
    title: "Bank Account Opening",
    description: "Simplified banking solutions with assistance in corporate account opening across leading financial institutions.",
    icon: "Landmark",
    image: "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbHMlMjBtZWV0aW5nfGVufDB8fHx8MTc3MTA2MDU0M3ww&ixlib=rb-4.1.0&q=80&auto=format&fit=crop&w=960",
    features: ["Corporate account setup", "Multi-currency accounts", "Banking relationships", "Documentation support"]
  },
  {
    id: 8,
    title: "Legal Assistance",
    description: "Simplified legal support to help businesses manage essential documentation, review agreements and navigate corporate legal requirements with confidence.",
    icon: "Scale",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?crop=entropy&cs=srgb&fm=jpg&q=80&auto=format&fit=crop&w=960",
    features: ["Wills drafting support", "MOA & AOA amendments", "POA preparation", "Commercial contracts & negotiations", "Lease agreement review"]
  },
  {
    id: 9,
    title: "Audit Assistance",
    description: "Simplified audit support to help businesses maintain compliance, verify financial records and prepare documentation with confidence.",
    icon: "FileCheck2",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=80&auto=format&fit=crop&w=960",
    features: ["Compliance review", "Financial record verification", "Liaison with auditors", "Documentation support"]
  }
];

export const aboutContent = {
  mission: "To deliver exceptional corporate services that drive business success and foster long-term partnerships built on trust, expertise, and measurable results.",
  vision: "To be the leading corporate services provider in the region, recognized for innovation, reliability, and client-centric solutions.",
  values: [
    { title: "Integrity", description: "We uphold the highest ethical standards in all our dealings" },
    { title: "Excellence", description: "We strive for excellence in every service we deliver" },
    { title: "Innovation", description: "We embrace innovative solutions to meet evolving business needs" },
    { title: "Partnership", description: "We build lasting relationships based on trust and mutual growth" }
  ],
  stats: [
    { label: "Years of Work Experience", value: "15+" },
    { label: "Happy Clients", value: "500+" },
    { label: "Services Offered", value: "9" },
    { label: "Success Rate", value: "98%" }
  ]
};

export const costCalculatorServices = [
  {
    id: "accounting",
    name: "Accounting & Bookkeeping",
    basePrice: 1500,
    options: [
      { id: "basic", name: "Basic Package (Monthly)", price: 1500 },
      { id: "standard", name: "Standard Package (Monthly)", price: 2500 },
      { id: "premium", name: "Premium Package (Monthly)", price: 4000 }
    ]
  },
  {
    id: "tax",
    name: "Tax Services",
    basePrice: 2000,
    options: [
      { id: "vat-registration", name: "VAT Registration", price: 1500 },
      { id: "vat-filing", name: "VAT Filing (Quarterly)", price: 2000 },
      { id: "tax-advisory", name: "Tax Advisory (Annual)", price: 5000 }
    ]
  },
  {
    id: "hr",
    name: "HR Services",
    basePrice: 3000,
    options: [
      { id: "recruitment", name: "Recruitment (Per hire)", price: 3000 },
      { id: "payroll", name: "Payroll Management (Monthly)", price: 2000 },
      { id: "hr-consulting", name: "HR Consulting (Project)", price: 5000 }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al Mansoori",
    company: "Tech Ventures LLC",
    role: "CEO",
    content: "Sumit Corporate Services made our company formation process seamless. Their expertise and attention to detail are exceptional.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Johnson",
    company: "Global Trading Co.",
    role: "Finance Director",
    content: "Outstanding accounting and tax services. They've helped us optimize our financial operations significantly.",
    rating: 5
  },
  {
    id: 3,
    name: "Rajesh Kumar",
    company: "Innovation Hub",
    role: "Managing Partner",
    content: "Professional, reliable, and always responsive. The best corporate services provider we've worked with.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does company formation take?",
    answer: "The timeline varies by jurisdiction. Free zone companies typically take 3-5 business days, while mainland companies may take 1-2 weeks depending on the activity and documentation."
  },
  {
    id: 2,
    question: "What documents are required for company registration?",
    answer: "Generally, you'll need passport copies, visa copies (if applicable), proof of address, and business plan. Specific requirements vary based on the jurisdiction and business activity."
  },
  {
    id: 3,
    question: "Do you provide VAT registration services?",
    answer: "Yes, we offer complete VAT registration and compliance services, including quarterly filing, tax planning, and audit support."
  },
  {
    id: 4,
    question: "Can you help with bank account opening?",
    answer: "Absolutely. We assist with corporate bank account opening across multiple banks, handling documentation and liaison to ensure a smooth process."
  },
  {
    id: 5,
    question: "What are your accounting service packages?",
    answer: "We offer flexible packages from basic bookkeeping to comprehensive financial management, tailored to your business size and needs."
  }
];

export const newsroomSocialLinks = {
  instagram: "https://www.instagram.com/sumit_corporate?igsh=bDVuOGUzOGlkOWk2&utm_source=qr",
  linkedin: "https://www.linkedin.com/company/sum-it-corporate-services-provider/",
  facebook: ""
};
